import { FeatureMouseInteraction } from '@openlayers/interaction/FeatureMouseInteraction';
import { Ajax } from '@shared/Ajax';
import { MapOverlays } from '@openlayers/ol-overlays';
import { setMapCursor } from '@openlayers/ol-utils';
import Feature from 'ol/Feature';
import { WindowManager } from '@shared/ui-react/FloatingWindow';
import { LabelService } from '@shared/services/LabelService';
import { DocumentsService } from '@shared/documents/DocumentsService';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { PdfOrExternalViewer } from '@shared/documents/ui/DocumentViewers';

export class GtPointDesktopMouseInteraction extends FeatureMouseInteraction {
    onClick = (feature: Feature, e, n, featuresAtPixel: Feature[]): void => {
        const data = feature.get('data');
        let html = [];
        featuresAtPixel.forEach(f => html.push(this.getDialogHTML(f)));

        MapOverlays.showDialog(
            this.map,
            "<div class='right'><i class='iki iki-cross' onclick='mapUI.hideDialog()'></i></div><div id=\"gt-info-popup\" class=\"padded of-a\">" + html.join('<hr>') + '</div>',
            e,
            n
        );
        setTimeout(() => {
            $('#gt-info-popup a').on('click', e => {
                if (e.shiftKey || e.ctrlKey || e.altKey) {
                    e.preventDefault();
                    WindowManager.openUrl((e.currentTarget as HTMLAnchorElement).href);
                }
            });
        }, 1);

        Ajax({
            url: `/api/1/file/${data.sourceModelId}/gt_link_file.json`,
        }).done((resp: { extras: any }) => {
            if (resp.extras && resp.extras.hasOwnProperty('targetType')) {
                let { targetType, target } = resp.extras;

                if (targetType == 0) {
                    // target is the document ID, fetch the full document object
                    DocumentsService.getDocumentById(target).then((idocument: IDocument) => {
                        const wrapper = document.getElementById('gt-point-link-wrapper');
                        if (wrapper) {
                            const root = createRoot(wrapper);
                            root.render(
                                React.createElement(PdfOrExternalViewer, {
                                    idocument,
                                    width: '600px',
                                    height: '500px',
                                    infoPosition: 'bottom',
                                })
                            );
                        }
                    });
                } else if (targetType == 1) {
                    if (target.indexOf('http') < 0) {
                        target = 'http://' + target;
                    }
                    $('#gt-point-link-wrapper').css('padding', '0 25px 15px').html(`<a href="${target}" target="_blank" rel="noopener">${target}</a>`);
                }
            }
        });
    };

    onMouseOver = (feature: Feature, e, n): void => {
        if (!feature.get('isLinePoint')) {
            setMapCursor(this.map, 'pointer');
        }
    };

    getDialogHTML(feature: Feature) {
        const point = feature.get('data');

        return LabelService.getHTMLLabelForOutlinePoint(point);
    }
}
